import { render } from "./AppFooter.vue?vue&type=template&id=62e67061&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=62e67061&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e67061"]])

export default __exports__